























import { Vue, Component } from 'vue-property-decorator'
interface route {
  title: string
  to: string
}
@Component({
  name: 'MyApproval'
})
export default class extends Vue {
  showNav = true
  routeList: route[] = [
    {
      title: 'VIP基本信息',
      to: '/trade/trade-vip-info/base-info'
    }
  ]
}
